import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { ListItemIcon, ListSubheader, Grid } from '@mui/material'
import DeletePriority from './DeletePriority'
import EditPriority from './EditPriority'
import PriorityIcon from '@mui/icons-material/LowPriority'
import schema from '../../schemas/priority.json'
import { JSONSchema7 } from 'json-schema'
import { Priority } from '../../interfaces/priority'
import CreatePriority from './CreatePriority'

export interface Props {
  disabled: boolean
  data: Priority[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function PriorityList({ disabled, data, setData }: Props) {
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'Priority'}
            <CreatePriority
              disabled={disabled || (data && data.length > 0)}
              data={data}
              schema={schema as JSONSchema7}
              setData={setData}
            />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: Priority, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditPriority disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <DeletePriority disabled={disabled} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>
                <PriorityIcon />
              </ListItemIcon>
              <ListItemText
                primary={obj.name}
                secondary={`${obj.first} ${obj.second && `→ ${obj.second}`} ${obj.third && `→ ${obj.third}`} ${
                  obj.fourth && `→ ${obj.fourth}`
                } ${obj.fifth && `→ ${obj.fifth}`}`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
